import rill from "rill";
import getSubscriberList from "./subscriber-list.controller";
import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions";

const SubscriberList = (app) => {
  app.at(
    "/subscribers/*",
    rill().setup((app) => {
      app.get(
        "/",
        (ctx, next) =>
          checkOrganizationSectionPermission(
            ctx,
            next,
            ["PUSH"],
            "/coaching-portal/athletes"
          ),
        getSubscriberList
      );
    })
  );
};

export default SubscriberList;
